import Types from 'Types';

export const getCoverUrl = (state: Types.RootState) => state.cover.coverUrl;
export const getNewCoverUrl = (state: Types.RootState) => state.cover.newCoverUrl;
export const getPredefinedImageIndex = (state: Types.RootState) => state.cover.predefinedImageIndex;
export const getImageSize = (state: Types.RootState) => state.cover.imageSize;
export const getIsPredefinedImage = (state: Types.RootState) => state.cover.isPredefinedImage;
